
export default function OurStory() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Our Story
            </h2>
            <p className="text-lg text-gray-600 mb-6">
              Marketing Ads was founded with one mission — to help businesses grow online through performance-driven marketing strategies.
            </p>
            <p className="text-gray-600 mb-6">
              We started as a small team of passionate digital marketers who believed that every business deserves to succeed online. Today, we've grown into a full-service marketing agency that specializes in e-commerce growth and performance marketing.
            </p>
            <p className="text-gray-600">
              Our journey has been driven by one simple principle: delivering measurable results that matter to our clients' bottom line.
            </p>
          </div>
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/d988ddb6325d7713b7b1640228e9b499.jpg"
              alt="Our marketing team working together"
              className="rounded-lg shadow-lg object-cover w-full h-80"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
